import React from 'react';
import BarButtonFw, { BUTTON_DEFAULT } from '../../../../../framework/bar-button/BarButtonFw';
import FormFw from '../../../../../framework/form/FormFw';
import GridFw, { COLUMN_DEFAULT, SELECTION_TYPE } from '../../../../../framework/grid/GridFw';
import { BasePage } from '../../../../../framework/pages/BasePage';
import { MessageUtil } from '../../../../../util/MessageUtil';
import FormGridFw, { FORM_GRID_MODE } from '../../../../../framework/form-grid/FormGridFw';
import { LoadUtil } from '../../../../../framework/util/LoadUtil';
import { getValidationEstacionModal } from './getValidationEstacionModal';
import { EnvConstants } from '../../../../../EnvConstants';

export class AgregarGrupoDestinatarioModal extends BasePage {
    constructor(props) {
        super(props);
        this.estacionData = {};
    };

    createPageProperties = (pageApi) => {
        return {
            validation: getValidationEstacionModal,
        };
    }

    renderPage(pageApi) {
        const validarForm = () => {
            if (this.estacionData.nombre_grupo_destinatario === "" || !this.estacionData.nombre_grupo_destinatario) {
                MessageUtil(
                    "warning",
                    "Alerta!",
                    "Nombre de Grupo Destinatario es requerido"
                );
                
                return false;
            }
            return true;
        }

        const barButtonconfig = {
            fields:[
                {...BUTTON_DEFAULT.SAVE , onClick: () => {
                    
                    if (validarForm()) {
                        const data = {
                            id_empresa: pageApi.name.data.id_empresa,
                            id_pers_contac: pageApi.name.data.id_pers_contac,
                            id_division: 1,
                            nombre_grupo_destinatario: this.estacionData.nombre_grupo_destinatario,
                        };

                        LoadUtil.loadByQueryId({
                            url: EnvConstants.GET_FW_FORM_URL_UPDATE_BASE(),
                            queryId: 847,
                            params: data,
                            fnOk: (res) => {
                                if(!res?.error) {
                                    MessageUtil("success", "Operación realizada con éxito.", "");
                                    pageApi.hideThisModal();
                                    pageApi.name.fnLoadForm()
                                } else {
                                    MessageUtil("error", res.message, "");
                                }  
                            }
                        })
                    }
                    

                }},
            ]
        }

        const formConfig = {
            mode: FORM_GRID_MODE.FORM_ADD,
            afterAddEvent: (data) => {
                console.log(data)
                pageApi.getEvent('afterAddEvent')(data);
                pageApi.hideThisModal();
            },
            form: {
                fields:[
                    {name:'nombre_grupo_destinatario', label:'Nombre Grupo Destinatario', column: 12, onChange: (value, values) => { this.estacionData.nombre_grupo_destinatario = value }, required: true},
                ]
            },
            bar: barButtonconfig
        } 

    
        return (
            <>
                <FormFw
                    name="grupoDestiForm" 
                    getParentApi={pageApi.getApi}
                    config={formConfig.form}
                />
                <BarButtonFw
                    name="bar"
                    getParentApi={pageApi.getApi}
                    config={barButtonconfig}
                />
            </>
        )

    }
    
}